import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { connect } from 'react-redux';

import { ERROR, LOADING, NONE, SUCCESS } from '../../../models/request-status';
import JSONModal from '../../modals/json-modal';
import { AccessToken } from '../../../../settings/single-sign-on/components/access-token';
import { activateToken, inspectCodeB } from '../../../../settings/single-sign-on/ssoActions';

import Modal from 'utils/components/modal';
import TextInput from 'utils/components/text-input';

class SSOIntegrationComponent extends Component {
  static displayName = 'SSOIntegration';

  static propTypes = {
    spotId: PropTypes.string.isRequired,
    sso: PropTypes.object,
    codeBData: PropTypes.object,
    activateToken: PropTypes.func,
    inspectCodeB: PropTypes.func
  };

  constructor(props, context) {
    super(props, context);

    this.state = { codeB: '', disabled: true };
  }

  @autobind
  onCodeBChange(codeB) {
    const isEmpty = codeB ? false : true;
    this.setState({ codeB, disabled: isEmpty });
  }

  @autobind
  activeToken() {
    let {
      spotId,
      sso: { accessToken }
    } = this.props;

    if (accessToken && accessToken.length > 0) {
      this.props.activateToken(accessToken);
    }
  }

  @autobind
  inspectCodeB() {
    let { codeB } = this.state;
    this.props.inspectCodeB(codeB);
  }

  renderCodeBButton() {
    let {
      codeBData: { status }
    } = this.props;
    const { disabled } = this.state;
    switch (status) {
      case LOADING:
        return (
          <button className="inspect-button" disabled={disabled} onClick={this.inspectCodeB}>
            <span className="spinner reset inspect-spinner" />
            Inspecting
          </button>
        );
      case SUCCESS:
      case ERROR:
        return (
          <div>
            <button className="inspect-button" disabled={disabled} onClick={this.inspectCodeB}>
              Inspect
            </button>
            <span className="link" onClick={this.openModal}>
              View JSON output
            </span>
          </div>
        );
      case NONE:
      default:
        return (
          <button className="inspect-button" disabled={disabled} onClick={this.inspectCodeB}>
            Inspect
          </button>
        );
    }
  }

  @autobind
  closeModal() {
    this.refs.urlData.hide();
  }

  @autobind
  openModal() {
    this.refs.urlData.show();
  }

  render() {
    let { codeB } = this.state;
    let {
      sso: { accessToken = '', isActive, isLoadingActivate },
      codeBData
    } = this.props;

    return (
      <div className="sso-integration">
        <h5 className="sso-title">SSO Integration</h5>
        <AccessToken
          accessToken={accessToken}
          isActive={isActive}
          isActivating={isLoadingActivate}
          onActivate={this.activeToken}
        />
        <h6 className="sso-subtitle">Code B Debugging</h6>
        <div className="code-b-text">
          {' '}
          Paste the code b you’ve received from the OpenWeb backend to validate the user details.
        </div>
        <TextInput
          className="sso-token"
          value={codeB || ''}
          onChange={this.onCodeBChange}
          placeholder="Enter code here..."
        />
        {this.renderCodeBButton()}
        <Modal ref="urlData" className="json-modal">
          <JSONModal onClose={this.closeModal} urlData={codeBData.body} />
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    sso: state.settings.sso.sso,
    codeBData: state.settings.sso.codeB
  };
}

function mapDispatchToProps(dispatch) {
  return {
    activateToken: token => dispatch(activateToken(token)),
    inspectCodeB: codeB => dispatch(inspectCodeB(codeB))
  };
}

const SSOIntegration = connect(mapStateToProps, mapDispatchToProps)(SSOIntegrationComponent);

export default SSOIntegration;
